// extracted by mini-css-extract-plugin
export default {"wrap":"announcementCreate_wrap__lyOz8","container":"announcementCreate_container__HjpdI"};